import React, { useContext, useEffect, useState } from 'react';
import Carousal from './Pages/Homepage/Carousal';
import Searchbar from './Components/Searchbar';
import Navbar from './Components/Navbar';
import Filtersearch from './Components/Filtersearch';
import { Link, Route, Routes } from 'react-router-dom';
import VideoPlay from './Pages/Videoplay/VideoPlay';
import Memberprofile from './Pages/MemberProfile/Memberprofile';
import offlineimage from './Assets/disconnected-4344475-3613903.webp';
import ManageVideos from './AdminPages/ManageVideos';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AddVideo from './AdminPages/Video/AddVideo';
import { Icon } from '@iconify/react';
import PrivateRoute from './Pages/PrivateRoute'
import Login from './Pages/Login/Login'
import FilterTable from './AdminPages/FilterTable'
import ViewVideo from './AdminPages/Video/ViewVideo'
import EditVideo from './AdminPages/Video/EditVideo'
import AddMember from './AdminPages/Member/AddMember'
import ViewMember from './AdminPages/Member/ViewMember'
import AddAdmins from './AdminPages/Manage-Admin/AddAdmins'
import ViewAdminDetails from './AdminPages/Manage-Admin/ViewAdminDetails'
import ViewComplaints from './AdminPages/Complaints/ViewComplaints'
import AddKla from './AdminPages/Kla/AddKla'
import AddSession from './AdminPages/Session/AddSession'
import GovAddress from './Pages/GovernersAddress.jsx/GovAddress'
import BudgetSpeech from './Pages/BudgetSpeech/BudgetSpeech'
import Rulings from './Pages/Rulings/Rulings'
import Archives from './Pages/Archives/Archives'
import SearchResult from './Pages/SearchResults.jsx/SearchResult'
import AddNew from './AdminPages/Video/AddNew'
import Drag from './Components/Drag'
import TableVideo from './AdminPages/Video/TableVideo';
import VideoR from './AdminPages/EveryRoutes/VideoR';
import GovR from './AdminPages/EveryRoutes/GovR';
import Home from './AdminPages/AdminHome.jsx/Home';
import HomeR from './AdminPages/EveryRoutes/HomeR';
import KLAR from './AdminPages/EveryRoutes/KLAR';
import SessionR from './AdminPages/EveryRoutes/SessionR';
import MemberMappingR from './AdminPages/EveryRoutes/MemberMappingR';
import SittingsR from './AdminPages/EveryRoutes/SittingsR';
import MembersR from './AdminPages/EveryRoutes/MembersR';
import EventR from './AdminPages/EveryRoutes/EventR';
import BudgetR from './AdminPages/EveryRoutes/BudgetR';
import RulingsR from './AdminPages/EveryRoutes/RulingsR';
import ConstituencyR from './AdminPages/EveryRoutes/ConstituencyR';
import SalutationR from './AdminPages/EveryRoutes/SalutationR';
import RoleR from './AdminPages/EveryRoutes/RoleR';
import AdminManageR from './AdminPages/EveryRoutes/AdminManageR';
import ComplaintR from './AdminPages/EveryRoutes/ComplaintR';
import DbStatusR from './AdminPages/EveryRoutes/DbStatusR';
import { addcontext } from './ContextShare/ContextShare';
import PageNotFound from './Components/PageNotFound';
import Maintenance from './Components/Maintenance';
import SSOTR from './AdminPages/EveryRoutes/SSOTR';
import WatchMan from './AdminPages/DbStatus/WatchMan';
import Stepper from './AdminPages/Stepper';
import FlowChart from './AdminPages/FlowChart';
import ConstituencyMappingR from './AdminPages/EveryRoutes/ConstituencyMappingR';
import ReservationR from './AdminPages/EveryRoutes/ReservationR';
import DocumentR from './AdminPages/EveryRoutes/DocumentR';
import PrivateRout from './PrivateRout';
import 'react-toastify/dist/ReactToastify.css';

function App() {
  const {videoData,setVideoData}=useContext(addcontext)
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const handleOnlineStatusChange = () => {
      setIsOnline(navigator.onLine);
      if (!navigator.onLine) {
        toast.warning("Network Connection Failed");
      } else {
        toast.success("Back to Online");
      }
    };
    window.addEventListener('online', handleOnlineStatusChange);
    window.addEventListener('offline', handleOnlineStatusChange);
    if (!navigator.onLine) {
      toast.warning("Network Connection Failed");
    }
    return () => {
      window.removeEventListener('online', handleOnlineStatusChange);
      window.removeEventListener('offline', handleOnlineStatusChange);
    };
  }, []);

  return (
    <>
      <ToastContainer
        position="top-center"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      {isOnline ? <Routes>


        <Route path='/' element={<Carousal />} />
        <Route path='/member' element={<Memberprofile />} />
        <Route path='/video/:vId' element={<VideoPlay />} />
        <Route path='*' element={<PageNotFound />} />
        <Route path='/maintenance' element={<Maintenance/>}/>
        <Route path='/governers-address' element={<GovAddress/>}/>
        <Route path='/budgetspeech' element={<BudgetSpeech/>}/>
        <Route path='/rulings' element={<Rulings/>}/>
        <Route path='/archives' element={<Archives/>}/>
        <Route path='/results' element={<SearchResult/>}/>
        <Route path='/skyblue' element={<Login />} />
        {/* protected routs */}
        <Route path="octobersky" element={<PrivateRout element={HomeR} />} />
        <Route path="octobersky/video" element={<PrivateRout element={VideoR} />} />
          <Route path='octobersky/governersaddress' element={<PrivateRout element={GovR}/>} />
          <Route path='octobersky/kla' element={<PrivateRout element={KLAR}/>} />
          <Route path='octobersky/session' element={<PrivateRout element={SessionR}/>} />
          <Route path='octobersky/session/member-mapping' element={<PrivateRout element={MemberMappingR}/>} />
          <Route path='octobersky/session/sittings' element={<PrivateRout element={SittingsR}/>} />
          <Route path='octobersky/members' element={<PrivateRout element={MembersR}/>} />
          <Route path='octobersky/members/ssot' element={<PrivateRout element={SSOTR}/>} />
          <Route path='octobersky/events' element={<PrivateRout element={EventR}/>} />
          <Route path='octobersky/budget-speech' element={<PrivateRout element={BudgetR}/>} />
          <Route path='octobersky/rulings' element={<PrivateRout element={RulingsR}/>} />
          <Route path='octobersky/constituency' element={<PrivateRout element={ConstituencyR}/>} />
          <Route path='octobersky/salutation' element={<PrivateRout element={SalutationR}/>} />
          <Route path='octobersky/role' element={<PrivateRout element={RoleR}/>} />
          <Route path='octobersky/manage-admins' element={<PrivateRout element={AdminManageR}/>} />
          <Route path='octobersky/complaints' element={<PrivateRout element={ComplaintR}/>} />
          <Route path='octobersky/dbstatus' element={<PrivateRout element={DbStatusR}/>} />
          <Route path='octobersky/constituency-mapping' element={<PrivateRout element={ConstituencyMappingR}/>} />
          <Route path='octobersky/reservation' element={<PrivateRout element={ReservationR}/>} />
          <Route path='octobersky/documentation' element={<PrivateRout element={DocumentR}/>} />
          <Route path='octobersky/add-user' element={<PrivateRout element={AddAdmins}/>} />

          <Route path='/st' element={<Stepper />} />
          <Route path='/fl' element={<FlowChart />} />

        {/*protected routes end */}


<Route path='/admin/viewvideo' element={<ViewVideo />} />

      </Routes>
        :
        <div className="flex flex-col items-center justify-center h-screen">
          <img
            src={offlineimage}
            alt="You are not connected"
            className="mb-8"
            style={{ width: '300px', height: '300px' }}
          />
          <h1 className="text-4xl font-bold text-gray-800 mb-4" onClick={() => toast.warning("Network Not Connected")}>
            You are not connected
          </h1>
          <p className="text-lg text-gray-600">Please check your internet connection and try again.</p>
        </div>
      }
    </>
  );
}

export default App;
